import React from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { Route, Routes, Navigate } from "react-router-dom";

import AuthLayout from "./layouts/Auth";
import LoginForm from "./LoginForm";
import Projects from "./Projects";
import Clients from "./Clients";
import ChangePassword from "./ChangePassword";

function AppRoutes() {

    const { route } = useAuthenticator((context) => [context.route]);
    const isLoggedIn = route === 'authenticated';

    return (
        <Routes>
            <Route path="/" element={<AuthLayout />}>
                {isLoggedIn ? (
                    <React.Fragment>
                        <Route path="/" index element={<Navigate to="/apps" />} />
                        <Route path="/apps" element={<Projects />} />
                        <Route path="/clients" element={<Clients />} />
                        <Route path="/profile" element={<ChangePassword />} />
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <Route index path="/" element={<LoginForm />} />
                        <Route path="/*" element={<Navigate to="/" />} />
                    </React.Fragment>
                )}
            </Route>
        </Routes >
    )
}

export default AppRoutes;